const columns = [
  {
    field: "barcode",
    title: "PRODUCT_BARCODE",
    editable: false,
    editor: "text",
    border: true,
    filter: true,
    show: true,
    min_width: 25,
  },
  {
    field: "productName",
    title: "PRODUCT_NAME",
    editable: false,
    editor: "text",
    border: true,
    filter: true,
    show: true,
    min_width: 20,
  },
  {
    field: "imageCount",
    title: "IMAGES_COUNT",
    editable: false,
    editor: "text",
    border: true,
    filter: true,
    show: true,
    min_width: 25,
  },
  {
    field: "trainedStatusFlag",
    title: "TRAINED_STATUS",
    editable: false,
    border: true,
    filter: true,
    min_width: 15,
    verified: true,
    show: true,
    filterType: "boolean",
    customFilter: true,
    filterData: [
      { tab: "Trained", value: "true" },
      { tab: "Untrained", value: "false" },
    ],
  },
]

export default columns
